import React from 'react';
import { Stack } from '@mui/material';
import { styled } from '@mui/system';
import { CareProgramTopicCard } from 'components/CareProgramTopicCard/CareProgramTopicCard';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { getHealthTopicTranslationKey } from 'features/resources/utils/healthTopicUtils';
import type { HealthTopic } from 'features/resources/types';

export interface CareProgramsTopicsGridProps {
  topics: HealthTopic[];
  onTopicClick: (topic: HealthTopic) => void;
  selectedTopic?: HealthTopic;
}

const TopicsContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3),
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overscrollBehaviorY: 'none',
  backgroundColor: theme.palette.background.paper,
  '& > *': {
    flexShrink: 0,
  },
}));

export const CareProgramsTopicsGrid: React.FC<CareProgramsTopicsGridProps> = ({
  topics,
  onTopicClick,
  selectedTopic,
}) => {
  const { translation } = useTranslationContext();

  return (
    <TopicsContainer spacing={1.5}>
      {topics.map((healthTopic) => {
        const title = translation(getHealthTopicTranslationKey(healthTopic));

        return (
          <CareProgramTopicCard
            key={healthTopic}
            healthTopic={healthTopic}
            title={title}
            onClick={() => onTopicClick(healthTopic)}
            selected={healthTopic === selectedTopic}
            variant="horizontal"
            ariaLabel={`View ${title} programs`}
          />
        );
      })}
    </TopicsContainer>
  );
};
